import { useState } from "react";
import { FAQS } from "../mock";
import { Plus, Minus } from "lucide-react";

export default function FAQ() {
  const [open, setOpen] = useState(0);

  return (
    <section id="faq" className="py-20 lg:py-28 bg-white">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <div className="max-w-2xl">
          <div className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-[0.18em] text-[#16d196]">
            <span className="w-1.5 h-1.5 rounded-full bg-[#16d196]" />
            Frequently asked
          </div>
          <h2 className="mt-4 text-[36px] lg:text-[56px] font-extrabold leading-[1.05] tracking-[-0.025em] text-[#0d1a2e]">
            Questions, <span className="text-[#16d196]">answered.</span>
          </h2>
          <p className="mt-5 text-[#0d1a2e]/65 text-[16.5px] leading-relaxed">
            Still unsure? Our investor team is happy to talk — no pressure, no sales
            calls. Just clear, plain-English answers.
          </p>
        </div>

        <div className="mt-12 space-y-3">
          {FAQS.map((f, i) => {
            const isOpen = open === i;
            return (
              <div
                key={i}
                className={`border rounded-2xl transition-colors ${
                  isOpen
                    ? "bg-[#f7faf9] border-[#16d196]/40"
                    : "bg-white border-[#0d1a2e]/10 hover:border-[#0d1a2e]/20"
                }`}
              >
                <button
                  onClick={() => setOpen(isOpen ? -1 : i)}
                  className="w-full flex items-center justify-between gap-4 px-5 lg:px-6 py-5 text-left"
                >
                  <span className="text-[15.5px] lg:text-[16.5px] font-bold text-[#0d1a2e] tracking-tight">
                    {f.q}
                  </span>
                  <span
                    className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-colors ${
                      isOpen ? "bg-[#16d196] text-[#0d1a2e]" : "bg-[#0d1a2e]/5 text-[#0d1a2e]"
                    }`}
                  >
                    {isOpen ? <Minus className="w-4 h-4" strokeWidth={2.6} /> : <Plus className="w-4 h-4" strokeWidth={2.6} />}
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 lg:px-6 pb-5 -mt-1 text-[14.5px] text-[#0d1a2e]/70 leading-relaxed">
                    {f.a}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
